// extracted by mini-css-extract-plugin
export default {"container":"defaultLayout_container__isLJ1","defContainer":"defaultLayout_defContainer__Wf0fH","conteudo":"defaultLayout_conteudo__NygQ0"};